import { createRootRoute, Outlet } from '@tanstack/react-router';
import { StreamWrapper } from '@/stream/stream-wrapper';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/context/theme-context';
import { ApplicationInsightsProvider } from '@/app-insights/application-insights-provider';
import { ReportClientInformation } from '@/components/report-client-information/report-client-information';
import { GTMProvider } from '@/google-tag-manager';
import { FirstLoginUsageAnalyticsDialog } from '@/components/first-login-usage-analytics-dialog/first-login-usage-analytics-dialog';
import '@/i18n/i18n';
import { ErrorBoundary } from '@/components/error-boundary';
import { queryClient } from '@/request-clients/query-client';
import { MsalProvider } from '@/auth/msal-provider';
import { AxiosProvider } from '@/request-clients/axios-provider';
import { useInitTranslations } from '@/i18n/use-init-translations';

const gtmConfig = { id: 'GTM-NNHBRCCW' };

export const Route = createRootRoute({
  component: () => {
    useInitTranslations();

    return (
      <main className="w-full relative">
        <MsalProvider>
          <AxiosProvider>
            <ThemeProvider>
              <ErrorBoundary>
                <QueryClientProvider client={queryClient}>
                  <ReportClientInformation />
                  <ApplicationInsightsProvider>
                    <GTMProvider config={gtmConfig}>
                      {/* <FirstTimeTermsAndConditionsDialog /> */}
                      <FirstLoginUsageAnalyticsDialog />
                      <StreamWrapper>
                        <Outlet />
                      </StreamWrapper>
                    </GTMProvider>
                  </ApplicationInsightsProvider>
                </QueryClientProvider>
              </ErrorBoundary>
            </ThemeProvider>
          </AxiosProvider>
        </MsalProvider>
      </main>
    );
  },
});
